import * as actionTypes from "../types";

const initialState = {
    addedCollection: false,
    deletedCollection: false,
    updatedCollection: false,
    selectedCollection: {},
    collections: [],
    collectionEmpty: false,
    error: null
}

export default function collectionReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.GET_COLLECTION: {
            return {
                ...state,
                collections: action.payload.collections,
                collectionEmpty: action.payload.collectionEmpty
            };
        }
        case actionTypes.SELECT_COLLECTION: {
            return {
                ...state,
                selectedCollection: action.payload,
            };
        }
        default: {
            return {
                ...state
            };
        }
    }
}


